import { useState } from 'react';

const useForceRender = () => {
  const render = useState({})[1];

  return () => render({});
};

export default useForceRender;
